import React from 'react';
import { Card, Badge } from './ui';
import { CheckCircle, Book, BookOpen, BookMarked, Gift } from 'lucide-react';
export function Product() {
  const tomos = [{
    icon: <Book className="w-8 h-8 text-blue-400" data-id="element-96" data-mp="28bal67kuhk7f" />,
    color: 'bg-blue-500/10 border-blue-500/20',
    title: 'TOMO 1 — ENTENDÉ Y MEJORÁ SU CONDUCTA',
    subtitle: 'Primero entendé. Después actuá.',
    desc: 'Cuando un niño grita, ignora una indicación, se niega a colaborar o repite una conducta una y otra vez, es fácil concentrarse únicamente en lo que está haciendo. Este tomo te ayuda a observar mejor esos momentos, identificar patrones y comprender qué puede haber detrás de determinadas conductas. Para pasar de “¿Por qué hace esto?” a “Ahora tengo más claridad sobre cómo abordarlo.”'
  }, {
    icon: <BookOpen className="w-8 h-8 text-emerald-400" data-id="element-97" data-mp="30zg8n23a9nay" />,
    color: 'bg-emerald-500/10 border-emerald-500/20',
    title: 'TOMO 2 — LÍMITES, RABIETAS Y EMOCIONES',
    subtitle: 'Acompañar una emoción no significa eliminar el límite.',
    desc: '¿Qué hacés cuando decís “no” y aparece una rabieta? ¿Qué pasa cuando se frustra? ¿Cedés? ¿Intentás explicarle? ¿Mantenés el límite? Herramientas para abordar rabietas, frustración, enojo, límites, emociones intensas y conflictos cotidianos. Porque podés reconocer lo que siente... sin dejar de sostener el límite.'
  }, {
    icon: <BookMarked className="w-8 h-8 text-amber-400" data-id="element-98" data-mp="2ejb48npraera" />,
    color: 'bg-amber-500/10 border-amber-500/20',
    title: 'TOMO 3 — RUTINAS Y PLAN DE CONDUCTA',
    subtitle: 'Menos improvisación. Más previsibilidad.',
    desc: 'Muchas discusiones aparecen alrededor de los mismos momentos: levantarse, vestirse, guardar juguetes, hacer tareas, apagar pantallas, bañarse y prepararse para dormir. Este tomo te ayuda a construir rutinas y un plan más claro para que el día no dependa constantemente de órdenes, recordatorios y negociaciones.'
  }];
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-99" data-mp="326jbhb6qvxvy">
      <div className="max-w-5xl mx-auto" data-id="element-100" data-mp="1275zfbvnqk1g">
        <div className="text-center mb-10" data-id="element-101" data-mp="y4rfspk5zg94">
          <Badge variant="success" className="mb-4" data-id="element-102" data-mp="y5squu16k2qu">
            🧩 PUNTO DIGITAL™ — KIT DE CONDUCTA INFANTIL
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-103" data-mp="1bxh4j1r2uz9x">
            3 Tomos + 5 Bonos
          </h2>
          <p className="text-xl text-slate-400" data-id="element-104" data-mp="173mk1w3neg9s">
            Un sistema práctico para dejar de improvisar frente a cada conducta
            difícil
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-6 text-sm font-medium text-brand-400" data-id="element-105" data-mp="1guhbrfzny82m">
            <span data-id="element-106" data-mp="1uuiaopwdb5fg">Entendé</span> <span className="text-slate-600" data-id="element-107" data-mp="1usxopoo4cut7">→</span>
            <span data-id="element-108" data-mp="1px0abnwf1yj2">Acompañá</span> <span className="text-slate-600" data-id="element-109" data-mp="1pwgs062ut84i">→</span>
            <span data-id="element-110" data-mp="gr11qe1glk0">Poné límites</span> <span className="text-slate-600" data-id="element-111" data-mp="i27jxyvc7et">→</span>
            <span data-id="element-112" data-mp="iu1738wnv2g">Organizá</span> <span className="text-slate-600" data-id="element-113" data-mp="3rnk655byd4tt">→</span>
            <span data-id="element-114" data-mp="3rp4yqpepidp1">Aplicá</span>
          </div>
        </div>

        <div className="mb-10" data-id="element-115" data-mp="274zrxaqk2hfk">
          <h3 className="text-xl font-bold text-white mb-5 flex items-center gap-3" data-id="element-116" data-mp="275t3cp0glv41">
            <span className="text-3xl" data-id="element-117" data-mp="2c31cy17jkqto">🧩</span> 3 TOMOS COMPLETOS
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-118" data-mp="1ydr42u24mkvc">
            {tomos.map((tomo, i) => <Card key={i} className={`border ${tomo.color}`} data-id="element-119" data-mp="22drjoi0yp23z" data-mpi={i}>
                <div className="flex items-start gap-4" data-id="element-120" data-mp="22c6pitik7l6n">
                  <div className="p-3 bg-slate-900 rounded-xl shrink-0" data-id="element-121" data-mp="1oe0cp18v4lzh">
                    {tomo.icon}
                  </div>
                  <div data-id="element-122" data-mp="1tbs1vni4htzz">
                    <h4 className="font-bold text-white text-lg mb-1" data-id="element-123" data-mp="1fed6m256us03">
                      {tomo.title}
                    </h4>
                    <p className="text-brand-400 text-sm font-medium mb-3" data-id="element-124" data-mp="1jgqasm4aehur">
                      {tomo.subtitle}
                    </p>
                    <p className="text-slate-400 text-sm leading-relaxed" data-id="element-125" data-mp="39q0bkhhso8u7">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </Card>)}
          </div>
        </div>

        <Card className="bg-slate-900" data-id="element-126" data-mp="2k3fsxg9g0nhg">
          <h4 className="font-bold text-xl text-white mb-6" data-id="element-127" data-mp="2k4igbe7k47sm">
            Qué te llevás con los 3 tomos:
          </h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-128" data-mp="2f6z38hmli129">
            {['Comprender mejor determinadas conductas', 'Identificar patrones', 'Tener nuevas herramientas para momentos de rabieta', 'Acompañar emociones sin abandonar los límites', 'Establecer límites con mayor claridad', 'Construir rutinas más predecibles', 'Tener un plan más consistente para situaciones que se repiten todos los días', 'Herramientas que te ayudan a aplicarlo en el día a día'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-129" data-mp="1mi1lqgq7k8ak" data-mpi={i}>
                <CheckCircle className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-130" data-mp="1ifwshj3o9dog" />
                <span className="text-slate-300" data-id="element-131" data-mp="3u0xcxnktv90g">{item}</span>
              </div>)}
          </div>
        </Card>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    title: 'TABLA DE RECOMPENSAS',
    desc: 'Una herramienta visual para definir pequeños objetivos, acompañar hábitos y responsabilidades y reconocer avances.',
    value: 'USD 7.00'
  }, {
    title: 'REGISTRO DE CONDUCTA',
    desc: 'Registrá qué pasó antes, durante y después de determinadas situaciones para empezar a identificar patrones que pueden pasar desapercibidos.',
    value: 'USD 7.00'
  }, {
    title: 'TARJETAS DE EMOCIONES',
    desc: 'Un apoyo visual para ayudar al niño a identificar, nombrar y expresar diferentes emociones cuando todavía le cuesta poner en palabras lo que siente.',
    value: 'USD 7.00'
  }, {
    title: 'PACK DE RUTINAS VISUALES',
    desc: 'Recursos visuales para hacer más predecibles momentos como vestirse, ordenar, bañarse, hacer tareas o prepararse para dormir. Menos repetir, más claridad sobre qué toca hacer y qué viene después.',
    value: 'USD 8.00'
  }, {
    title: 'ACUERDO FAMILIAR DE CONDUCTA',
    desc: 'Una herramienta para establecer reglas, responsabilidades y acuerdos familiares de manera más clara y consistente.',
    value: 'USD 8.00'
  }];
  return <section className="py-12 px-4" data-id="element-132" data-mp="25m9dcjsx0vlu">
      <div className="max-w-5xl mx-auto" data-id="element-133" data-mp="25nay5fzqgwgr">
        <div className="text-center mb-8" data-id="element-134" data-mp="21lphdjk2vy1a">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 flex items-center justify-center gap-3" data-id="element-135" data-mp="21n0jlexvkxqa">
            <Gift className="w-9 h-9 text-brand-400" data-id="element-136" data-mp="2fmi95wizwf0p" />5 BONOS PRÁCTICOS
          </h2>
          <p className="text-xl text-brand-400 font-bold uppercase tracking-widest" data-id="element-137" data-mp="2akj9awmgs08i">
            Siempre incluidos
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-id="element-138" data-mp="3m1ja6gmvnne5">
          {bonuses.map((bono, i) => <Card key={i} className="relative overflow-hidden group hover:border-brand-500/50 transition-colors flex flex-col" data-id="element-139" data-mp="17t07ealhw0vc" data-mpi={i}>
              <div className="absolute top-0 right-0 bg-brand-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-140" data-mp="1cq8ijr8874n3">
                BONO {i + 1}
              </div>
              <h4 className="font-bold text-white text-lg mb-3 pr-12 mt-2" data-id="element-141" data-mp="13sga970x8x97">
                {bono.title}
              </h4>
              <p className="text-slate-400 text-sm mb-6" data-id="element-142" data-mp="1rjv6ci23uic0">{bono.desc}</p>
              <div className="mt-auto pt-4 border-t border-slate-800 flex justify-between items-center" data-id="element-143" data-mp="1vikun5oolkaf">
                <span className="line-through text-slate-500 text-sm" data-id="element-144" data-mp="1hrfodkqt5tr4">
                  Valor {bono.value}
                </span>
                <span className="text-emerald-400 font-bold" data-id="element-145" data-mp="2agd6nnv0rqjv">GRATIS</span>
              </div>
            </Card>)}
        </div>

        <div className="bg-gradient-to-r from-brand-900/50 to-emerald-900/50 border border-brand-500/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-146" data-mp="2f84zk51ne8d6">
          <p className="text-slate-300 mb-2" data-id="element-147" data-mp="f6nbf0iicp7b">Valor de los bonos</p>
          <p className="text-4xl font-black text-white mb-2 line-through decoration-red-500/50" data-id="element-148" data-mp="acj2ibpom73l">
            USD 37.00
          </p>
          <p className="text-2xl font-bold text-emerald-400" data-id="element-149" data-mp="5co8hzam11eb">
            → INCLUIDOS GRATIS CON TU KIT
          </p>
        </div>

        <div className="max-w-3xl mx-auto mt-10 text-center" data-id="element-150" data-mp="y3y7ydcr94j2">
          <p className="text-lg font-bold text-white mb-3" data-id="element-151" data-mp="y1bzmbi1ikzs">
            No estás comprando simplemente 3 PDFs.
          </p>
          <p className="text-slate-400 mb-6" data-id="element-152" data-mp="o4z91mhskn99">
            Estás obteniendo un sistema organizado para tener herramientas
            frente a situaciones que aparecen todos los días.
          </p>
          <div className="grid sm:grid-cols-2 gap-3 text-left" data-id="element-153" data-mp="38vhhrzwcv42o">
            {['3 Tomos completos', '5 Bonos prácticos', 'Herramientas para comprender conductas', 'Recursos para acompañar emociones', 'Estrategias para establecer límites', 'Apoyo para construir rutinas', 'Materiales visuales para llevarlo a la práctica', 'Todo organizado dentro de un único Kit'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-154" data-mp="1y3rydy29solh" data-mpi={i}>
                <CheckCircle className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-155" data-mp="1y5cv9uc24jmi" />
                <span className="text-slate-300" data-id="element-156" data-mp="234pf067mtakv">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}